import { IInitialState } from "./types";

export const initialState: IInitialState = {
  marathonId: null,
  marathonWithDistances: {
    data: null,
    loading: false,
    error: null,
  },
  marathonAdminById: {
    data: null,
    loading: false,
    error: null,
  },
  userRegistered: {
    data: null,
    loading: false,
    error: null,
  },
  marathons: {
    params: {
      page: 1,
      pageSize: 10,
      orderBy: null,
      corporateClientId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  marathonsDistancesPrice: {
    params: {
      marathonId: null,
      distanceId: null,
      promocodeId: null,
      includeInsurance: false,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  marathonsById: {
    params: {
      marathonId: null,
      insurance: false,
      distance: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  marathonsAsAdmin: {
    params: {
      marathonId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  marathonsDistances: {
    params: {
      marathonId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  marathonsActive: {
    params: {
      page: 1,
      pageSize: 10,
      orderBy: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  myMarathonsWithUnfinishedRegistration: {
    params: {
      page: 1,
      pageSize: 10,
      orderBy: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  marathonsHasUserInsurance: {
    params: {
      marathonId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  deleteMarathons: {
    data: null,
    loading: false,
    error: null,
  },
  deleteMarathonsNonActivatedPromocodes: {
    data: null,
    loading: false,
    error: null,
  },
  marathonsLookupId: null,
  marathonsLookupLoading: false,
  marathonsLookup: {
    params: {
      page: 1,
      pageSize: 10,
      allMarathonsLookup: null,
      hasMore: true,
      loading: false,
      name: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    },
  },
  marathonParticipantImages: {
    params: {
      page: 1,
      pageSize: 10,
      marathonId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    }
  },
  marathonMyParticipantImages: {
    params: {
      page: 1,
      pageSize: 10,
      marathonId: null,
    },
    response: {
      data: null,
      loading: false,
      error: null,
    }
  },
};
